import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

/**
 * StatusFilter component for filtering suggestions by status
 * Used in suggestion list views
 */
const StatusFilter = ({ value, onChange, label = "Status Filter", sx = {} }) => {
  return (
    <FormControl sx={{ minWidth: 200, ...sx }}>
      <InputLabel id="status-filter-label">{label}</InputLabel>
      <Select
        labelId="status-filter-label"
        id="status-filter"
        value={value}
        label={label}
        onChange={onChange}
      >
        <MenuItem value="pending">Pending</MenuItem>
        <MenuItem value="approved">Approved</MenuItem>
        <MenuItem value="rejected">Rejected</MenuItem>
        <MenuItem value="all">All</MenuItem>
      </Select>
    </FormControl>
  );
};

export default StatusFilter;
